module.exports = __webpack_public_path__ + "img/liberty.7bf2fbd5.png";